import ContractTypeMdl from '@/models/HumanResource/HrContractType'
//
export default () => {
    try {
        let response = ContractTypeMdl.params({ get_all_results: true }).get()
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}
